import { create } from 'zustand';

type GlobalErrorStore = {
  error: string | null;
  setError: (message: string) => void;
  clearError: () => void;
};

export const useGlobalErrorStore = create<GlobalErrorStore>((set) => ({
  error: null,
  setError: (message) => set({ error: message }),
  clearError: () => set({ error: null }),
}));
